(() => {
  function init(root) {
    root.querySelectorAll('[data-ln-product]').forEach((section) => {
      const form = section.querySelector('[data-ln-product-form]');
      if (!form || form.dataset.lnReady) return;
      form.dataset.lnReady = 'true';
      const input = form.querySelector('[name="id"]');
      const button = form.querySelector('.product-submit');
      const price = section.querySelector('[data-ln-price]');
      const error = form.querySelector('[data-ln-cart-error]');
      const status = form.querySelector('[data-ln-cart-status]');
      let busy = false;
      const selected = () => input.tagName === 'SELECT' ? input.selectedOptions[0] : input;
      const update = () => {
        const option = selected();
        if (option?.dataset.price) price.innerHTML = option.dataset.price;
        else price.textContent = 'Unavailable';
        const available = option?.dataset.available === 'true';
        button.disabled = busy || !available;
        button.textContent = available ? 'Add to selection' : option ? 'Sold out' : 'Unavailable';
      };
      input.addEventListener('change', () => {
        update();
        error.hidden = true;
        const url = new URL(window.location.href);
        if (input.value) url.searchParams.set('variant', input.value);
        else url.searchParams.delete('variant');
        window.history.replaceState(window.history.state, '', url);
      });
      const picker = form.querySelector('[data-ln-option-picker]');
      if (picker && input.tagName === 'SELECT') {
        const groups = [...picker.querySelectorAll('[data-ln-option-group]')];
        const variants = [...input.options].map(option => ({
          id: option.value, values: JSON.parse(option.dataset.options),
          available: option.dataset.available === 'true'
        }));
        const notice = picker.querySelector('[data-ln-option-notice]');
        const values = () => groups.map(group => group.querySelector('input:checked')?.value);
        const refresh = () => {
          const chosen = values();
          const match = variants.find(v => v.values.every((value, i) => value === chosen[i]));
          groups.forEach((group, index) => {
            group.querySelectorAll('input[type="radio"]').forEach(radio => {
              const matches = variants.filter(v => v.values.every((value, i) => value === (i === index ? radio.value : chosen[i])));
              const available = matches.some(v => v.available);
              // Keep choices reachable so a visitor can change two dependent options.
              const label = radio.closest('label');
              label.classList.toggle('is-unavailable', !available);
              label.title = available ? '' : matches.length ? 'Sold out with the current options' : 'Unavailable with the current options';
            });
          });
          notice.hidden = Boolean(match?.available);
          notice.textContent = !match ? 'This combination is unavailable. Please choose another option.' : !match.available ? 'This combination is currently sold out.' : '';
          return match;
        };
        const syncFromVariant = () => {
          const variant = variants.find(v => v.id === input.value);
          if (!variant) return;
          groups.forEach((group, index) => group.querySelectorAll('input[type="radio"]').forEach(radio => {
            radio.checked = radio.value === variant.values[index];
          }));
          refresh();
        };
        picker.addEventListener('change', event => {
          if (!event.target.matches('input[type="radio"]')) return;
          const match = refresh();
          input.value = match?.id || '';
          input.dispatchEvent(new Event('change', {bubbles: true}));
        });
        input.addEventListener('change', syncFromVariant);
        syncFromVariant();
        input.hidden = true;
        form.querySelector('[data-ln-variant-label]').hidden = true;
        picker.hidden = false;
      }
      update();
      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        if (busy || button.disabled || !form.reportValidity()) return;
        const body = new FormData(form);
        // Shopify's bundled section response keeps the cart badge authoritative.
        body.set('sections', 'header');
        body.set('sections_url', window.location.pathname);
        busy = true;
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        error.hidden = true;
        status.textContent = 'Adding to your selection.';
        try {
          const response = await fetch(form.action.replace(/\/?$/, '.js'), {
            method: 'POST', body, credentials: 'same-origin', headers: { Accept: 'application/json' }
          });
          const result = await response.json();
          if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : 'Unable to add this piece. Please try again.');
          let count;
          if (result.sections?.header) {
            const html = new DOMParser().parseFromString(result.sections.header, 'text/html');
            const badge = html.querySelector('[data-cart-count]');
            if (badge && /^\d+$/.test(badge.textContent.trim())) count = Number(badge.textContent.trim());
          }
          if (count === undefined) {
            try {
              const cartResponse = await fetch(form.dataset.cartUrl.replace(/\/?$/, '.js'), {credentials: 'same-origin', cache: 'no-store', headers: {Accept: 'application/json'}});
              if (!cartResponse.ok) throw new Error('Cart refresh failed');
              count = (await cartResponse.json()).item_count;
            } catch (_) { /* The add succeeded: never repeat it or redirect. */ }
          }
          document.querySelectorAll('[data-cart-count]').forEach((badge) => {
            badge.textContent = Number.isInteger(count) ? String(count) : '+';
            const bag = badge.closest('a');
            bag?.setAttribute('aria-label', Number.isInteger(count) ? `Shopping bag, ${count} items` : 'Shopping bag, item added');
            bag?.classList.remove('ln-cart-added');
            if (bag) { void bag.offsetWidth; bag.classList.add('ln-cart-added'); }
          });
          status.textContent = 'Added to your selection.';
          document.dispatchEvent(new CustomEvent('ln:cart-updated', {detail: {itemCount: count}}));
        } catch (e) {
          error.textContent = e.message || 'Unable to add this piece. Please try again.';
          error.hidden = false;
          status.textContent = '';
        } finally {
          busy = false;
          button.removeAttribute('aria-busy');
          update();
        }
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
  else init(document);
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
